import { computed } from '@ember/object';

export default function (key) {
  return computed(`${key}.[]`, 'itemsPerPage', 'page', function () {
    let models = this.get(key);
    let page = this.get('page');
    let total = this.get('itemsPerPage');
    let start = (page - 1) * total;
    let end = start + total;

    if (models) {
      return models.slice(start, end);
    }

    return models;
  });
}
